import os from 'node:os'
import 'winston-daily-rotate-file'
import { createLogger, format, transports } from 'winston'
// CJS package without proper ESM exports; handle default interop for Vite SSR
import _ConsoleTransport from 'winston-humanize-console-transport'
const ConsoleTransport = (_ConsoleTransport as any).default || _ConsoleTransport

const { combine, timestamp } = format

const isProduction = process.env.NODE_ENV === 'production'

const defaultMeta: Record<string, unknown> = {
  pid: process.pid,
  host: os.hostname(),
  app: 'pixai-app-ssr',
  commitId: process.env.GIT_COMMIT_ID || process.env.VITE_COMMIT_HASH || '',
}

const logger = createLogger({
  defaultMeta,
  format: combine(timestamp()),
  // Production: file-only via DailyRotateFile added below; no stdout/stderr
  // Development: humanized colored output (matches pixai-server)
  transports: isProduction ? [] : [new ConsoleTransport()],
  level: process.env.LOG_LEVEL || 'info',
})

if (isProduction) {
  const rotateFileDir = process.env.LOG_TRANSPORT_FILE_DIR || './logs'

  logger.add(
    new transports.DailyRotateFile({
      datePattern: 'YYYY-MM-DD',
      zippedArchive: true,
      maxFiles: '14d',
      format: format.json(),
      createSymlink: true,
      dirname: rotateFileDir,
      filename: 'pixai-app-ssr-%DATE%.log',
    }),
  )
}

export default logger

// Guard against duplicate handler registration during Vite SSR HMR
const g = globalThis as any
if (!g.__pixaiLoggerHandlersRegistered) {
  g.__pixaiLoggerHandlersRegistered = true

  process.on('uncaughtException', err => {
    logger.error(err.message, { stack: err.stack, type: 'error' })
  })

  process.on('unhandledRejection', reason => {
    const message =
      reason instanceof Error
        ? reason.message
        : `unhandled rejection: ${reason}`
    const stack = reason instanceof Error ? reason.stack : undefined
    logger.error(message, { stack, type: 'error' })
  })
}
